import stressTestimonials from '@/app/[locale]/stress/_data/stressTestimonials';
import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

const StressTestimonials = () => {
  return (
    <LandingPageTestimonials
      data-cy="stress-testimonials"
      testimonials={stressTestimonials}
      theme="purple"
    />
  );
};

export default StressTestimonials;
